<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-12 09:51:22
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-24 16:39:59
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\goodsInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="yx-color-text-primary font-h6-regular">
		<div class="yx-color-text-secondary">
			<p>二级团服务费率：{{ row.serviceFeeRate | formatEmpty | formatPercent2 }}</p>
			<p>达人佣金率：{{ row.commissionRate | formatEmpty | formatPercent2 }}</p>
		</div>
		<p>是否人工审核：{{ row.auditStatus === '1' ? '是' : '否' }}</p>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	computed: {
		promotion({ row }) {
			let status = row.promotionStatus || '1';
			let obj = {
				1: {
					label: '推广中',
					type: 'success',
					isDisabled: true,
				},
				2: {
					label: '中止推广',
					type: 'error',
					isDisabled: false,
				},
				3: {
					label: '已失效',
					type: 'primary',
					isDisabled: true,
				},
			};
			return obj[status];
		},
	},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped>
</style>